import { type FC } from "react";
import * as styles from "./styles.css";

const Status = {
  inWanted: "募集中",
  notInWanted: "募集なし",
} as const;

type StatusKeys = keyof typeof Status;

type Props = {
  status: "inWanted" | "notInWanted";
};

export const WantedStatusLabel: FC<Props> = ({ status }) => {
  const statusKey: StatusKeys = status;

  return <span className={styles.statusLabel[statusKey]}>{Status[statusKey]}</span>;
};
